import { useState } from "react";
import { Row, Col, Spin } from "antd";
import { isEmpty } from "lodash";

// Adding local dependencies here
import Filters from "./componenets/filters/filters";
import ScoreBoard from "./componenets/scoreBoard/scoreBoard";
import ChartComparisonForDifferentScoreType from "./componenets/chartComparisonForDifferentScoreType/chartComparisonForDifferentScoreType";
import TableView from "./componenets/tableView/tableView";
// import CardView from "./componenets/cardView/cardView";
import "./dataQualityReport.scss";
import { useDataQualityReportStore } from "@stores/dataQualityReport";
import DataNotFound from "@components/noDataFound";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

const DataQualityReport = () => {
  const [view, setView] = useState("table");
  const selectedScoreType = useDataQualityReportStore((state) => state.selectedScoreType);
  const scoreBoardValue = useDataQualityReportStore((state) => state.scoreBoardValue);
  const scoreBoardLoading = useDataQualityReportStore((state) => state.scoreBoardLoading);
  const [tableLoader, setTableLoader] = useState(false);

  const handleViewChange = (view: string) => {
    setView(view);
  };

  return (
    <div className="data-quality-report">
      <div className="data-quality-report__header">
        <div className="data-quality-report__header__title">Data Quality Dashboard</div>
        <div className="data-quality-report__header__route">
          Reports / <span className="data-quality-report__header__route__active">Data Quality Dashboard</span>
        </div>
      </div>
      <div className="data-quality-report__body">
        <div className="data-quality-report__body__header">
          <span className="data-quality-report__body__header__title">{view === "table" ? "Data Quality Score" : "Data Quality Score Month-wise"}</span>
          <span className="data-quality-report__body__header__filter">
            {/* FIlters */}
            <Filters view={view} onViewChange={handleViewChange} disableDateRange={view !== "table"} />
          </span>
        </div>
        <Spin spinning={scoreBoardLoading} indicator={<HealthemSpinner size={45} />}>
          <div className="data-quality-report__body__content">
            {/* if ScoreBoardResult is null then render Empty else as is  */}
            {/* depending upon the view either it is Table view or graph View put a condition over here */}
            {/* if view is table view then  */}
            {view === "table" ? (
              !isEmpty(scoreBoardValue) ? (
                <div className="data-quality-report__body__content__table-view">
                  <Row>
                    <Col span={5}>
                      {/* Score Board */}
                      <ScoreBoard setTableLoader={setTableLoader}/>
                    </Col>
                    <Col span={19} className="data-quality-report__body__content__table-view__col">
                      <h2 className="data-quality-report__body__content__table-view__label">{selectedScoreType?.label}</h2>
                      {/* table view or card view depending upon  the selected score type */}
                      {/* {selectedScoreType?.id === "Completeness" || selectedScoreType?.id === "Uniqueness" ? <TableView height={window.innerHeight - 370} /> : <CardView />} */}
                      <TableView loader={tableLoader} height={window.innerHeight - 420} />
                    </Col>
                  </Row>
                </div>
              ) : (
                <DataNotFound message={scoreBoardLoading ? "" : "No file processing details available for the selected criteria."} />
              )
            ) : (
              //  if view is area graph view then
              <div className="data-quality-report__body__content__graph-view">
                <ChartComparisonForDifferentScoreType />
              </div>
            )}
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default DataQualityReport;
